import {
  type ContextType,
  type Dispatch,
  type FC,
  type PropsWithChildren,
  type SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

type DrawerState =
  | { open: false }
  | { open: true; type: 'policy'; isEditing: false }
  | { open: true; type: 'policy'; isEditing: true; id: string };

const Context = createContext<
  | {
      drawerState: DrawerState;
      setDrawerState: Dispatch<SetStateAction<DrawerState>>;
    }
  | undefined
>(undefined);

const _useContext = (): NonNullable<ContextType<typeof Context>> => {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useDrawerState must be used within DrawerProvider.');
  }
  return context;
};

export const useDrawerState = () => {
  return _useContext();
};

export const DrawerStateProvider: FC<PropsWithChildren> = ({ children }) => {
  const [drawerState, setDrawerState] = useState<DrawerState>({ open: false });

  return (
    <Context.Provider value={{ drawerState, setDrawerState }}>
      {children}
    </Context.Provider>
  );
};
